// eslint-disable-next-line import/prefer-default-export
export const MINIMUM_RESIDENCE_HISTORY = 36;
